import { decryptFromStoreLoc } from '../helper';

export const getAuthToken = () => {
    const tokenData = decryptFromStoreLoc('token');
    const token = tokenData?.token || '';
    return token;
};